import { normalizePlacement, samePlacement, toPlacement, type Placement } from '../../utils/dashboard';
import type { DashboardWidget } from './Dashboard';

type SavedWidget = {
    id: string;
    enabled: boolean;
    layout: Placement;
};

export type SavedDashboardLayout = {
    id: string;
    name: string;
    hideEmptyWidgets: boolean;
    widgets: SavedWidget[];
};

export function captureDashboardLayout(name: string, widgets: DashboardWidget[], hideEmptyWidgets: boolean): SavedDashboardLayout {
    return {
        id: `saved:${crypto.randomUUID()}`,
        name: name.trim(),
        hideEmptyWidgets,
        widgets: widgets.map(({ id, enabled, layout }) => ({
            id,
            enabled,
            layout: toPlacement(layout)
        }))
    };
}

export function applySavedDashboardLayout(widgets: DashboardWidget[], saved: SavedDashboardLayout): DashboardWidget[] {
    const byId = new Map(saved.widgets.map((widget) => [widget.id, widget]));
    return widgets.map((widget) => {
        const stored = byId.get(widget.id);
        if (!stored) return { ...widget, layout: { ...widget.layout } };
        return {
            ...widget,
            enabled: stored.enabled,
            layout: {
                ...widget.layout,
                ...normalizePlacement(stored.layout, widget.layout),
                i: widget.id
            }
        };
    });
}

export function matchesSavedDashboardLayout(widgets: DashboardWidget[], hideEmptyWidgets: boolean, saved: SavedDashboardLayout): boolean {
    if (hideEmptyWidgets !== saved.hideEmptyWidgets || widgets.length !== saved.widgets.length) return false;
    const byId = new Map(saved.widgets.map((widget) => [widget.id, widget]));
    return widgets.every((widget) => {
        const stored = byId.get(widget.id);
        return stored !== undefined && widget.enabled === stored.enabled && samePlacement(widget.layout, stored.layout);
    });
}
